import { COURSE_TEMPLATE_NAMES, resolveCourseDetailPresentation } from 'lib/coursePresentation';
import './CourseThemePreview.css';

const descriptions = {
  'editorial-parallax': 'Large editorial heading, glass outline card and an open, ruled curriculum.',
  'wine-split': 'DOT, compliance and incident topics: red and blue accents, a reversed split hero, evidence-style panels and a divided curriculum.',
  'data-room': 'Dispatch, operations and accounting: teal and blue accents, a centered heading, a wide glass dashboard and a structured curriculum.',
  'process-index': 'Safety, onboarding and training: warm orange accents, circular background patterns, a prominent progress card and a step-by-step curriculum.',
};

export default function CourseThemePreview({ record }) {
  const theme = resolveCourseDetailPresentation(record);
  return (
    <div className="aw-course-theme-preview" data-course-theme-preview={theme.key} style={{ '--preview-accent': theme.accent, '--preview-secondary': theme.secondaryAccent || theme.accent }}>
      <div className="aw-course-theme-sketch" aria-hidden="true">
        <div className="aw-course-theme-sketch-copy"><i /><b /><b /><span /><span /><em /></div>
        <div className="aw-course-theme-sketch-summary"><i /><span /><span /></div>
        <div className="aw-course-theme-sketch-curriculum"><i /><i /><i /></div>
      </div>
      <div>
        <p className="aw-course-theme-name">{COURSE_TEMPLATE_NAMES[theme.key]}</p>
        <p className="aw-muted">{descriptions[theme.key]}</p>
        <p className="aw-muted">This shared design applies whenever this preset is selected for an existing or future course. Save, then open Preview saved content to review the full page with your course information.</p>
      </div>
    </div>
  );
}
